import logError from "seneca-common/utils/sentry/logError";

const UPDATED_BEFORE_RELOAD_SESSION_KEY = "seneca.pwa.updatedBeforeReload";

export function setUpdatedBeforeReloadFlag() {
  try {
    window.sessionStorage &&
      window.sessionStorage.setItem(UPDATED_BEFORE_RELOAD_SESSION_KEY, "true");
  } catch (err: any) {
    logError(err, {
      message: "Could not set recentlyUpdated in sessionStorage"
    });
  }
}

export function getUpdatedBeforeReloadFlag() {
  try {
    return (
      window.sessionStorage &&
      window.sessionStorage.getItem(UPDATED_BEFORE_RELOAD_SESSION_KEY)
    );
  } catch (err: any) {
    logError(err, {
      message: "Could not get recentlyUpdated in sessionStorage"
    });
  }
}

export function removeUpdatedBeforeReloadFlag() {
  try {
    window.sessionStorage &&
      window.sessionStorage.removeItem(UPDATED_BEFORE_RELOAD_SESSION_KEY);
  } catch (err: any) {
    logError(err, {
      message: "Could not remove recentlyUpdated in sessionStorage"
    });
  }
}
